// extracted by mini-css-extract-plugin
export default {"header":"Plan_header__cFznl","dataWrapper":"Plan_dataWrapper__993Cg","special":"Plan_special__SuWRa","footer":"Plan_footer__EskY3","box":"Plan_box__VgOk9"};